import { extendZodWithOpenApi } from '@anatine/zod-openapi';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { OKGeneric } from '../../models';

extendZodWithOpenApi(z);
const c = initContract();

/**
 * Admin Dispatch (Notifications, Emails, etc) API
 */
export const apiAdminDispatch = c.router({
  dispatchInactiveTrackerNotifications: {
    method: 'GET',
    path: `/1.0/admin/dispatch/notifications/memory_tracker_status`,
    summary:
      'Dispatches in-app notifications about inactive tracker sessions (e.g, no uploads for 2+ working days)',
    description:
      'Scans for users with inactive Memory tracker sessions and dispatches in-app notifications to alert them. Identifies users who have not uploaded tracker data for 2 or more working days and sends appropriate reminder notifications.',
    responses: {
      200: OKGeneric,
    },
  },
});
